import type { LucideIcon } from 'lucide-react';
import { Card, CardBody } from '@vnetwork/ui/primitives';
import { Stat } from '@vnetwork/ui/data';

/**
 * Shared headline stat card + grid: bordered `Card` with a colored corner icon,
 * a large value and a muted hint — the canonical @ui metric card used across the
 * Capacities dashboard and cloud drill-downs. Uses `Stat` for the label/value/hint
 * pattern; the corner icon is composed via a flex wrapper since `Stat` has no icon
 * slot. Icon colors must be semantic solid tokens (theme-reactive).
 */
export interface StatCardItem {
  label: string;
  value: string | number;
  hint: string;
  icon: LucideIcon;
  color: string;
}

const GRID: React.CSSProperties = {
  display: 'grid',
  gap: 'var(--vn-space-4)',
  gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))',
};

export function StatCardGrid({ items }: { items: StatCardItem[] }) {
  return (
    <div style={GRID}>
      {items.map((c) => {
        const Icon = c.icon;
        return (
          <Card key={c.label} flat style={{ height: '100%' }}>
            <CardBody>
              <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: 'var(--vn-space-2)' }}>
                <Stat
                  label={c.label}
                  value={c.value}
                  hint={c.hint}
                  style={{ flex: 1, minWidth: 0 }}
                />
                <Icon size={18} style={{ color: c.color, flexShrink: 0, marginTop: 'var(--vn-space-1)' }} aria-hidden />
              </div>
            </CardBody>
          </Card>
        );
      })}
    </div>
  );
}
